// extracted by css-extract-rspack-plugin
export default {"groupHeading":"styles-module__groupHeading__tR4kX","searchInputWrapper":"styles-module__searchInputWrapper__bIMeq","searchSpinner":"styles-module__searchSpinner__NGViI"};